import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/header/Cart.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/NewsletterForm.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/LiveChat.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/src/contexts/LiveChatContext.tsx")